module.exports = __webpack_public_path__ + "static/media/logo_rindegastos_hdr.60b6932c.png";